import React, { useState, useEffect } from 'react';
import { Carousel, Container, Row, Col } from 'react-bootstrap';
import "./slides.css"

function ControlledCarousel() {
const [index, setIndex] = useState(0);

const imageArray = [
    {
        src: 'https://i.ibb.co/r6999y3/IMG-1571.jpg',
        alt: 'Image 1',
        caption: "Her husband has full confidence in her and lacks nothing of value. She brings him good, not harm, all the days of her life."
    },
    {
        src: 'https://i.ibb.co/Fs4rFSw/IMG-0062.jpg',
        alt: 'Image 2',
        caption: 'He who finds a wife finds what is good and receives favor from the Lord.',
    },
    {
        src: 'https://i.ibb.co/BBs2V4p/IMG-0063.jpg',
        alt: 'Image 3',
        caption: 'Houses and wealth are inherited from parents, but a prudent wife is from the Lord.',
    },
    {
        src: 'https://i.ibb.co/jLjtLjC/IMG-0084.jpg',
        alt: 'Image 4',
        caption: 'Two are better than one, because they have a good return for their labor.',
        },
        {
        src: 'https://i.ibb.co/RBDfVJy/IMG-0078.jpg',
        alt: 'Image 5',
        caption: 'Though one may be overpowered, two can defend themselves. A cord of three strands is not quickly broken.',
        },
        {
        src: 'https://i.ibb.co/G2Cgtf6/IMG-0860.jpg',
        alt: 'Image 6',
        caption: 'She openeth her mouth with wisdom; and in her tongue is the law of kindness.',
        },
        {
        src: 'https://i.ibb.co/3FHkvW5/e8f24e65-9d94-4895-8eed-4df1e146f527.jpg',
        alt: 'Image 7',
        caption: 'A good woman is hard to find, and worth far more than diamonds.',
        },
        {
        src: 'https://i.ibb.co/93KXzFD/032b7a53-db2b-427a-8fe9-a8ef704fba9a.jpg',
        alt: 'Image 8',
        caption: 'Many women have done wonderful things, but you’ve outclassed them all!',
        },
        {
        src: 'https://i.ibb.co/F6jPfch/5d4c2cb1-e93d-41d0-b9d3-8279a79ddf49.jpg',
        alt: 'Image 9',
        caption: 'The woman to be admired and praised is the woman who lives in the Fear-of-God.',
        },
        {
        src: 'https://i.ibb.co/V30RGQZ/eb033c6e-4e7c-4435-a988-b35a18a6c945.jpg',
        alt: 'Image 10',
        caption: 'Your wife shall be like a fruitful vine Within the innermost part of your house',
        },
        {
        src: 'https://i.ibb.co/F5xDzZD/31e742ab-e69e-481a-96ca-51f594aff982.jpg',
        alt: 'Image 11',
        caption: 'An excellent wife is the crown of her husband, but she who shames him is as rottenness in his bones.',
        }
    ];

const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
};

const autoChangeCarousel = () => {
    if (index < imageArray.length - 1) {
    handleSelect(index + 1);
    } else {
    handleSelect(0);
    }
};

useEffect(() => {
    const intervalId = setInterval(autoChangeCarousel, 5000);

    return () => {
    clearInterval(intervalId);
    };
}, [index]);

const imageContainerStyle = {
    width: '100%',
    height: 'auto',
};

const imageStyle = {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
};

return (
    <Container>
    <Row className="justify-content-center">
        <Col>
        <Carousel activeIndex={index} onSelect={handleSelect}>
            {imageArray.map((imageData, carouselIndex) => (
            <Carousel.Item key={carouselIndex}>
                <div style={imageContainerStyle}>
                <img src={imageData.src} alt={imageData.alt} style={imageStyle} />
                <p className="text-center mt- custom-text">
                    {imageData.caption}
                </p>
                </div>
            </Carousel.Item>
            ))}
        </Carousel>
        </Col>
    </Row>
    </Container>
);
}

export default ControlledCarousel;
